import { DataPoint, Node } from '@policygenius/dif-ts-types';

/**
 * When given a urn and an Interview Node, will find the dataType for the urn.
 * If no Node is found with the given urn, will return null.
 *
 * NOTE: Currently, this function will not find a urn that is part of a Compositie, Repeatable DPID.
 * This function will need to be extended in order to handle those urns properly.
 *
 * @param urn
 * @param node
 * @returns DataPoint['dataType'] | null
 */
const getDataTypeFromNode = (urn: string, node: Node): DataPoint['dataType'] | null => {
  if (node.nodeType === 'QUESTION' && node.dataPoint.urn === urn) {
    return node.dataPoint.dataType;
  }

  if (node.nodeType === 'SECTION') {
    for (const child of node.children) {
      const dt = getDataTypeFromNode(urn, child);

      if (dt) {
        return dt;
      }
    }
  }

  return null;
};

export default getDataTypeFromNode;
